import { render } from "./SiteContactsForm.vue?vue&type=template&id=52418bec&ts=true"
import script from "./SiteContactsForm.ts?vue&type=script&lang=ts"
export * from "./SiteContactsForm.ts?vue&type=script&lang=ts"

import "./SiteContactsForm.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__